<template>
  <div id="basket_match_outer" class="vue_body_min_height" >
    <div v-if="currentBanner != null">
      <div>
        <img id="match_top_img" :src="currentBanner.url">
      </div>
    </div>

    <div class="container">
      <div class="row" id="match_courses_center"
           style="padding-left: 30px;padding-right: 30px;" v-if="trainings != null && trainings.length > 0">
        <div class="basket-match-card-title"><span>课程中心</span></div>

        <div id="course_item_outer" class="row">
          <div v-for="(item, index) in trainings"
               :class="[courseCenterStyleSelect(index), 'col-xs-12', 'course-item']"
              >
            <a class="col-xs-12 col-sm-6" :href="courseItemPath(item)" >{{item.title}}</a>
            <a class="col-xs-12 col-sm-6" style="font-size: 1rem" :href="courseItemPath(item)">{{item.subtitle}}</a>
          </div>

        </div>
      </div>

      <div class="row"  style="padding-left: 15px;padding-right: 15px;">
        <div class="basket-match-card-title" ><span>裁判员/教练员认证</span></div>
        <div class="apply-buttons">
          <el-button :disabled="!isUserAllowedApply || !isJudgeApplyAllowed" @click="gotoApplyJudgeButtonClicked" round>裁判员身份认证<span v-if="!isJudgeApplyAllowed">（暂未开放）</span>>></el-button>
          <el-button :disabled="!isUserAllowedApply" @click="gotoCoachApplyButtonClicked" round>教练员身份认证>></el-button>
        </div>
      </div>

      <div id="match_judge" class="row"  style="padding-left: 15px;padding-right: 15px;" v-if="referees != null && referees.length > 0">
        <div class="basket-match-card-title" ><span>裁判员培训</span></div>
        <div class="row train-card" >
          <div class="col-xs-12 col-sm-6 image-item">
            <img :src="refereePostImage">
          </div>
          <div class="col-xs-12 col-sm-6 content-item">
            <div>
              <a v-for="(item, index) in referees"
                  :href="activityItemSrc(item)"
                  class="item-a"

                 v-on:mouseover="refereeActivityOver(index)"
                 v-on:mouseout="refereeActivityOut(index)"
                 :key="'referee_train_' + index"
              >
                {{item.actionTitle}}
              </a>

              <div class="item-bottom-buttons" style="flex-wrap:wrap;justify-content: flex-start;flex-wrap: nowrap;">
                <input type="button" value="查看更多内容 >" @click="judgeButtonClicked">
                <input type="button" value="认证裁判员列表 >" @click="certifiedJudgeButtonClicked">
              </div>
              <!-- <div class="item-bottom-buttons" v-if="isJudgeApplyAllowed" style="flex-wrap:wrap;justify-content: flex-start;">
                <input type="button" value="立即认证 >" @click="gotoApplyJudgeButtonClicked" />
              </div> -->
            </div>
          </div>
        </div>
      </div>

      <div id="match_coach" class="row"  style="padding-left: 30px;padding-right: 30px;" v-if="coachs != null && coachs.length > 0">
        <div class="basket-match-card-title"><span>教练员培训</span></div>
        <div class="row train-card">
          <div class="col-xs-12 col-sm-6 image-item">
            <img :src="coachPostImage">
          </div>

          <div class="col-xs-12 col-sm-6 content-item">
            <div>
              <a v-for="(item, index) in coachs"
                 :href="activityItemSrc(item)"
                 class="item-a"
                 v-on:mouseover="coachActivityOver(index)"
                 v-on:mouseout="coachActivityOut(index)"
                 :key="'coach_train_' + index"
              >
                {{item.actionTitle}}
              </a>

              <div class="item-bottom-buttons" style="flex-wrap:wrap;justify-content: flex-start;flex-wrap: nowrap;">
                <input type="button" value="查看更多内容 >" @click="coachButtonClicked">
                <input type="button" value="认证教练员列表 >" @click="coachListButtonClicked">
              </div>
              <!-- <div class="item-bottom-buttons" v-if="isCoachApplyAllowed" style="flex-wrap:wrap;justify-content: flex-start;">
                <input type="button" value="立即认证 >" @click="gotoCoachApplyButtonClicked" />
              </div> -->

            </div>
          </div>

        </div>
      </div>

      <div id="sml_basketball_train" class="row" style="padding-left: 15px;padding-right: 15px;" v-if="coachs != null && coachs.length > 0">
        <div class="basket-match-card-title"><span>小篮球培训</span></div>
        <div class="row train-card">
          <div class="col-xs-12 col-sm-6 image-item">
            <img :src="smlTrainImage">
          </div>

          <div class="col-xs-12 col-sm-6 content-item">
            <div>
              <a v-for="(item, index) in miniBasketball"
                 :href="activityItemSrc(item)"
                 class="item-a"
                 v-on:mouseover="smlTrainActivityOver(index)"
                 v-on:mouseout="smlTrainActivityOut(index)"
                 :key="'small_coach_train_' + index"
              >
                {{item.actionTitle}}
              </a>

              <div class="item-bottom-buttons">
                <input type="button" value="查看更多内容 >" @click="smlTrainButtonClicked">
                <input type="button" value="证书查询 >" @click="smlTrainCertificateSearchClicked">
              </div>
            </div>
          </div>

        </div>
      </div>

    </div>

  </div>
</template>

<script>
import GlobalInstance from '../js/shba'
import TrainList from "../components/train/TrainList";
import CertifiedList from "../components/train/CertifiedList";
export default {
  name: "BasketballTrainingPage",
  components:{
    CertifiedList,
    TrainList,
  },
  data() {
    return {
      title: '篮球培训',

      trainItem: null,

      bootstrapMd: false,
      refereeIndex: 0,
      coachIndex: 0,
      smlTrainIndex: 0,
      judgeApplyDuration: null,
      isUserAllowedApply: true,
    }
  },
  mounted() {
    this.initData();
    this.monitScreenSizeChanged();
    $(window).resize(this.monitScreenSizeChanged);
    this.loadData();
    this.getJudgeIdentificationDateDuration();

    let shareObj = this.$store.state.http.defaultShareObj;
    shareObj.title = '篮球培训';
    shareObj.link = location.href;
    this.configShareWx(encodeURIComponent(location.href), shareObj);

  },
  destroyed() {
  },
  computed: {
    httpManager() {
      return this.$store.state.http;
    },
    isCoachApplyAllowed() {
      let user = this.$store.state.dataStore.getUser();
      if (user == null) {
        return true;
      } else {
        if (user.isTeam == 1) {
          return false;
        } else {
          return true;
        }
      }
    },

    isJudgeApplyAllowed() {
      let judgeApplyDuration = this.judgeApplyDuration;
      if (judgeApplyDuration == null) {
        return false;
      }
      let beginString = judgeApplyDuration.begin;
      let enditString = judgeApplyDuration.end;
      let beginDate = this.$moment(beginString);
      let endDate = this.$moment(enditString);
      let now = this.$moment(this.$moment().format("yyyy-MM-DD"), "yyyy-MM-DD");
      if ((now - beginDate) >= 0 && (now - endDate) <= 0) {
        let user = this.$store.state.dataStore.getUser();
        if (user == null) {
          return true;
        } else {
          if (user.isTeam == 1) {
            return false;
          } else {
            return true;
          }
        }
      }
      return false;
    },

    banners() {
      return this.$store.state.banners;
    },
    currentBanner() {
      if (this.banners == null) {
        return null;
      }
      let item = this.banners.find(function (item) {
        return  item.name == 'training';
      });

      if (item == undefined) {
        return null;
      }
      return item;
    },

    subTabList() {
      return GlobalInstance.methods.subMenuLlist(this.$route)
    },

    referees() {
      return this.trainItem == null ? null : this.trainItem.referees;
    },

    coachs() {
      return this.trainItem == null ? null : this.trainItem.coachs;
    },

    miniBasketball() {
      return this.trainItem == null ? null : this.trainItem.miniBasketball;
    },

    trainings() {
      return this.trainItem == null ? null : this.trainItem.trainings;
    },

    refereePostImage() {
      let referees = this.referees;
      if (referees == null || referees.length == 0) {
        return '';
      }
      return referees[this.refereeIndex].imageUrls;
    },

    coachPostImage() {
      let coachs = this.coachs;
      if (coachs == null || coachs.length == 0) {
        return '';
      }
      return coachs[this.coachIndex].imageUrls;
    },
    smlTrainImage() {
      let miniBasketball = this.miniBasketball;
      if (miniBasketball == null || miniBasketball.length == 0) {
        return '';
      }
      return miniBasketball[this.smlTrainIndex].imageUrls;
    }

  },
  methods: {
    initData() {
      let user = this.$store.state.dataStore.getUser();
      console.log('caoch === apply -- begin');
      console.log(user);
      if (user != null && user.isTeam == 1) { // 团体用户不允许身份认证
      console.log('不允许申请！！！');
        this.isUserAllowedApply = false;
        return;
      }
      this.isUserAllowedApply = true;
    },
    gotoCoachApplyButtonClicked() {
      let user = this.$store.state.dataStore.getUser();
      let url = null;
      if (user != null) {
        url = this.$router.resolve({
          name: 'personalHomeVue'
        });
      } else {
        url= this.$router.resolve({
          name: 'loginPage',
        });
      }
      window.open(url.href,"_blank");
    },
    gotoApplyJudgeButtonClicked() {
      let user = this.$store.state.dataStore.getUser();
      let url = null;
      if (user != null) {
        url = this.$router.resolve({
          name: 'personalHomeVue'
        });
      } else {
        url= this.$router.resolve({
          name: 'loginPage',
        });
      }
      window.open(url.href,"_blank");
    },

    getJudgeIdentificationDateDuration() {
      let judgeApplyDuration = this.judgeApplyDuration;
      if (judgeApplyDuration == null) {
        let _this = this;
        this.httpManager.ajax.getJudgeApplyDateData(function (data) {
          if (data.code == 0) {
            let value = data.data.value;
            let duration = JSON.parse(value);
            _this.judgeApplyDuration = duration;
            // _this.splitUnCompletedJudgeData();
            return;
          }
        }, function (data) {

        });
      }
    },

    refereeActivityOver(index) {
      this.refereeIndex = index;
    },
    refereeActivityOut(index) {
      this.refereeIndex = 0;
    },
    coachActivityOver(index) {
      this.coachIndex = index;
    },
    coachActivityOut(index) {
      this.coachIndex = 0;
    },

    smlTrainActivityOver(index) {
      this.smlTrainIndex = index;
    },
    smlTrainActivityOut(index) {
      this.smlTrainIndex = 0;
    },

    activityItemSrc(item) {
      let web = item.newsUrl;
      if (web != null && web.length > 0) {
        return web;
      }
      return '/news/0302/0/' + item.id;
    },


    loadData() {
      let _this = this;
      this.$store.state.http.ajax.vmTraining(function (data) {
        console.log(data);
        let code = data.code;
        if (code == 0) {
          _this.trainItem = data.data;
          return;
        }
        _this.$toast('请求失败！');
      }, function (data) {
        _this.$toast('请求失败，请重试！');
      })
    },
    courseCenterStyleSelect(index) {
      return index < (this.trainings.length - 1) ? 'course-bottom-border' : '';
    },
    monitScreenSizeChanged() {
      // if (this.currentIndex != -1) {
      //   return 0;
      // }

      var winWide = window.screen.width;
      let tempWidth = $("#course_item_outer").outerWidth();
      if (tempWidth >= 716) {
        this.bootstrapMd =true;
      } else {
        this.bootstrapMd =false;
      }
    },
    courseItemPath(item) {

      // return 'javascript:void(null);';

      let web = item.newsUrl;
      if (web != null && web.length > 0) {
        return web;
      }
      return '/training' + '/course/' + item.id;
    },

    judgeButtonClicked() {
      this.gotoSubMenuPage(0);
    },
    coachListButtonClicked() {
      let id = this.subTabList[1].id;
      let routeUrl = this.$router.resolve({
        name: 'coachPage',
        params: {
          id
        }
      });
      window.open(routeUrl.href,"_blank");
    },
    certifiedJudgeButtonClicked() {
      // 裁判员列表页
      let id = this.subTabList[0].id;
      let routeUrl = this.$router.resolve({
        name: 'RefereePage',
        params: {
          id
        }
      });
      window.open(routeUrl.href,"_blank");
    },
    coachButtonClicked() {
      this.gotoSubMenuPage(1);
    },

    smlTrainButtonClicked() {
      this.gotoSubMenuPage(2);
    },

    smlTrainCertificateSearchClicked() {
      this.gotoSubMenuPage(2);
    },

    // CertifiedCoachButtonClicked() {
    //   this.gotoSubMenuPage(3);
    // },
    gotoSubMenuPage(index) {
      let id = this.subTabList[index].id;
      let routeUrl = this.$router.resolve({
        name: 'TrainingListActivityPage',
        params: {
          id,
        }
      });
      window.open(routeUrl.href,"_blank");
    }

  }
}
</script>

<style scoped>
  #basket_match_outer {
    padding-bottom: 80px;
    text-align: center;
  }

  #match_top_img {
    width: 100%;
    height: auto;
  }

  .basket-match-card-title {
    margin-top: 30px;
  }

  .basket-match-card-title span {
    font-size: 2rem;
    font-weight: bold;
    border-bottom: solid 2px #fc1a34;
    padding-bottom: 5px;
    letter-spacing: 1.5px;
  }

  #match_courses_center > div:last-child {
    margin-top: 30px;
  }

  #match_courses_center .course-item {
    /*height: 30px;*/
    position: relative;
    padding: 6px 0px;
    align-items: center;
    display: flex;
    justify-content: flex-start;

    flex-direction: row;
  }

  @media screen and (min-width: 768px) {
    #match_courses_center .course-item {
      /*justify-content:space-around;*/

    }
  }

  .course-item a {
    color: white;
    font-size: 1.2rem;
    text-decoration: none;
  }

  .course-item a:hover {
    color: #aaa;
  }


  #match_courses_center .course-bottom-border {
    border-bottom: solid 1px rgba(102, 102, 102, 0.15);
  }

  #course_item_outer {
    border-radius: 6px;
    background-color: #fc1a34;
  }


  .train-card {
    margin-top: 6vh;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: center;
  }

  .train-card .image-item > img {
    width: 100%;
    height:auto;
  }

  .train-card .content-item {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    padding-top: 20px;
    padding-bottom: 20px;
  }

  .train-card .content-item > div {
    max-width: 90%;
    width: auto;
    text-align: left;
  }

  .train-card .content-item .item-a {
    color: #333;
    font-size: 1.2rem;
    text-decoration: none;
    display: block;
  }

  .train-card .content-item .item-a:not(:first-child) {
    margin-top: 10px;
  }

  .train-card .content-item .item-a:hover {
    color: #fc1a34;
  }

  .item-bottom-buttons {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
  }

  .item-bottom-buttons input {
    font-size: 1.2rem;
    border: none;
    background-color: #fc1a34;
    border-radius: 30px;
    color: white;
    padding: 10px 15px;
    margin-top: 20px;
    font-weight: bold;
    outline: none;
  }

  .item-bottom-buttons input:not(:first-child) {
    margin-left: 15px;
  }

  #basket_match_outer .apply-buttons {
    margin-top: 6vh;
  }

  #basket_match_outer .apply-buttons .el-button {
    background-color: #FC1A34;
    border-color: #FC1A34;
    color: white;
    width: 90%;
  }

  #basket_match_outer .apply-buttons .el-button:disabled {
    background-color: #bbb;
    border-color: #bbb;
    color: white;

  }


  #basket_match_outer .apply-buttons .el-button:last-child {
    margin-top: 15px;
  }

  @media screen and (min-width: 768px) {
    #basket_match_outer .apply-buttons .el-button {
      background-color: #FC1A34;
      border-color: #FC1A34;
      color: white;
      width: 30%;
      max-width: 330px;
    }

    #basket_match_outer .apply-buttons .el-button:last-child {
      margin-top: 0;
    }

    .train-card .content-item > div {
      max-width: 70%;
    }

    #match_coach .train-card {
      flex-direction: row-reverse;
    }

    #sml_basketball_train .item-bottom-buttons {
      justify-content: flex-start;
    }

    .item-bottom-buttons {
      justify-content: flex-start;
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/BasketballTrainingPage.vue